<template>
  <div v-if="patient">
    <div class="title mb-2 text-uppercase">
      {{ $t("transaction_detail_patient.title") }}
    </div>
    <div>
      {{ patient.email }}
    </div>
    <div>
      {{ $t("transaction_detail_patient.phone") }}:
      {{ patient.phone }}
    </div>
  </div>
</template>


<script>
export default {
  name: "transaction-detail-patient",
  props: {
    patient: {
      type: Object,
      default: undefined,
    },
  },
  fallbackI18n: {
    messages: {
      und: {
        transaction_detail_patient: {
          title: "Contact info",
          phone: "Contact phone",
        },
      },
    },
  },
};
</script>


<style lang="scss" scoped>
.title {
  font-weight: bold;
}
</style>
